import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { ServicesService } from 'src/app/services/services.service';

@Component({
  selector: 'app-modal-pro-features',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './modal-pro-features.component.html',
  styleUrl: './modal-pro-features.component.scss'
})
export class ModalProFeaturesComponent {
  @Input() visible: boolean = false
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() subscriptionSuccess = new EventEmitter<boolean>();

  proSubscription: Subscription
  loadingSubscription: boolean = false

  constructor(
    private servicesService: ServicesService
  ) { }

  onDialogHide() {
    this.visibleChange.emit(false);
  }

  buySubscriptionNow() {
    this.loadingSubscription = true
    this.proSubscription = this.servicesService.subscribe('Pro features').subscribe(result => {
      if (result) {
        this.loadingSubscription = false
        this.subscriptionSuccess.emit(true)
        this.onDialogHide()
      }
    });
  }
}
